export const METRIC_PROBLEMS = {
    dau_metric: ["DAU"],
    arpdau_metrics: [
        "ARPDAU",
        "ads_ARPDAU",
        "is_ARPDAU",
        "rw_ARPDAU",
        "bn_ARPDAU",
        "native_ARPDAU",
        "iap_ARPDAU",
        "sub_ARPDAU",
    ],
    general_engagement_metrics: [
        "SumME0",
        "sumR1",
        "Song_Start_User",
        "Song_Fail_User",
        "Song_Result_User",
        "Song_End_User",
        "Song_Revive_User",
        "Song_Unlock_User",
    ],
    early_funnel: [
        "Activation_rate",
        "__Users___Tutorial_Start",
        "__User___Tutorial_Result",
        "__Users___song_start_after_Tutorial",
        "Tutorial_Result_Per_Start",
    ],
    fail_behavior: ["Song_Fail_Rate"],
    user_value: ["UV0", "UV14", "Sub_UV7", "IAP_UV"],
    ad_impression: [
        "FS_Imp_User_D0",
        "RV_Imp_User_D0",
        "Revive_Imp_User_D0",
        "Unlock_Imp_User_D0",
        "AOA_Imp_User_D0",
        "BN_Imp_User_D0",
    ],
    ad_ecpm: ["RV_eCPM", "FS_eCPM", "AOA_eCPM", "BN_eCPM"],
};
